export default class Media {
  id;
  mediableId;
  type;
  externalPlatform;
  localPath;
  externalLink;
  isCover;
  constructor(data) {
    this.id = data?.id;
    this.mediableId = data?.mediable_id;
    this.type = data?.type;
    this.externalLink = data?.external_link;
    this.localPath = data?.local_path
      ? process.env.VUE_APP_BASE_URL + data?.local_path
      : null;
    this.externalPlatform = data?.external_platform;
    this.isCover = data?.is_cover;
  }
}
